module.exports = __webpack_public_path__ + "static/media/img_account.d43003d5.svg";